import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../common/DataTable/PrimeDataTable";

const ProductDetailsList = ({ persona }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: "createdAt",
    sortOrder: -1
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchProductDetails();
  }, [paginationParams]);

  const fetchProductDetails = async () => {
    setLoading(true);
    try {
      // admin users see all product details
      const response = await axiosInstance.get(`/api/product-details`, { withCredentials: true });
      setData(response?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
    { field: "id", header: "ID", sortable: true },
    { 
      field: "request.certificate_license_number", 
      header: "License Number", 
      sortable: true, 
      filter: true,
      body: (rowData) => rowData?.request?.certificate_license_number || '-'
    },
    { 
      field: "proposed_trade_name_in_english", 
      header: "Trade Name", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "inn_scientific_name", 
      header: "Generic Name", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "dosage_form", 
      header: "Dosage Form", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "concentration", 
      header: "Concentration", 
      sortable: true,
      body: (rowData) => rowData.concentration ? `${rowData.concentration} ${rowData.concentration_unit || ''}` : '-'
    },
    { 
      field: "request.drugPricingForm.marketing_authorization_holder", 
      header: "MAH", 
      sortable: true, 
      filter: true,
      body: (rowData) => rowData?.request?.drugPricingForm?.marketing_authorization_holder || '-'
    },
    { 
      field: "requestProgressStatus", 
      header: "Status", 
      sortable: true, 
      filter: true,
      body: (rowData) => rowData?.requestProgressStatus || 'Active'
    },
    { 
      field: "end_user.username",
      header: "Applicant Name",
      sortable: true,
      filter: true,
      body: (rowData) => rowData?.end_user?.username || '-'
    },
    {
      field: "request.study_name",
      header: "Request Name",
      sortable: true,
      filter: true,
      body: (rowData) => rowData?.request?.study_name || '-'
    },
    { 
      field: "registrationDate", 
      header: "Registration Date", 
      sortable: true, 
      filter: true, 
      body: (rowData) => {
        return rowData.registrationDate ? new Date(rowData.registrationDate).toLocaleString('en-GB') : '-';
      }
    },
    { 
      field: "renewalDate", 
      header: "Renewal Date", 
      sortable: true, 
      filter: true, 
      body: (rowData) => {
        return rowData.renewalDate ? new Date(rowData.renewalDate).toLocaleString('en-GB') : '-';
      }
    },
    { 
      field: "updatedAt", 
      header: "Last Updated", 
      sortable: true, 
      filter: true, 
      body: (rowData) => {
        return rowData.updatedAt ? new Date(rowData.updatedAt).toLocaleString('en-GB') : '-';
      }
    }
  ];

  const actions = [
    { 
      text: "View Details", 
      color: 'primary', 
      onClick: (row) => navigate(`/${persona}/product-details/details/${row.id}`) 
    }
  ];

  return (
    <div>
      <DataTableComponent
        data={data}
        columns={columns}
        loading={loading}
        paginationParams={paginationParams}
        totalRecords={data?.length}
        onDataTableEvent={onDataTableEvent}
        enableCreate={false}
        enablePagination={true}
        enableLazyLoading={false}
        enableExport={true}
        actions={actions}
        sectionName={`Product-Details-${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}-${new Date().getHours()}-${new Date().getMinutes()}`}
      />
    </div>
  );
};

export default ProductDetailsList;

